import { DashboardProvider } from "../dashboard/DashboardContext";
import { LoginProvider } from "../login/LoginContext";
import { UserProvider } from "../userDetails/UserContext";
import { ChangePasswordProvider } from "../changepassword/ChangePasswordContext";    

const ReportProviderContext = ({ children }) => {
    return (       
            <LoginProvider>                
                <DashboardProvider>
                     <UserProvider>
                        <ChangePasswordProvider>
                        {children}
                        </ChangePasswordProvider>
                    </UserProvider>
                </DashboardProvider>
            </LoginProvider>
        
    );
};
export default ReportProviderContext;